export default "__VITE_ASSET__BTOlwiNk__"